const Store = {
    storeList: () => 'store/associated-stores',
    switchStore: (storeId: string) => `store/switch/${storeId}`,
}
export default Store